import { ref } from 'vue'

export const access = ref(null)
export const hasRole = role => {
  const levels = { viewer: 1, analyst: 2, editor: 3, admin: 4 }
  return (levels[access.value?.user?.role] || 0) >= (levels[role] || 99)
}
export const privateStorageKey = key => access.value?.mode === 'local'
  ? key : `uchecking:${access.value?.user?.id || 'anonymous'}:${key}`
